module.exports = __webpack_public_path__ + "4b07dea1073646009da86fdd868248ab.svg";